import { jsx, jsxs } from 'react/jsx-runtime';
import { createContext, useContext, useRef } from 'react';
import { Images } from '../../../assets/ui/images/icons/index.js';
import { LineIcon } from '../../ui/icons/LineIcon.js';
import { Skeleton } from '../../ui/skeleton.js';
import { useDevice } from '../../../contexts/DeviceContext.js';
import { cn } from '../../../lib/utils.js';

const CertificationCardContext = createContext(null);
const CertificationCardSkeleton = ({
  title,
  className,
  children
}) => {
  const { isDesktop } = useDevice();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "certification-card w-full flex flex-col rounded-[12px] border border-basic-04 bg-base-white",
        !title && "pt-5",
        className
      ),
      children: [
        title && /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "flex items-center justify-between gap-2 p-5 pb-5",
              isDesktop && "p-6 pb-5"
            ),
            children: /* @__PURE__ */ jsx(Skeleton, { className: "w-1/2 h-6" })
          }
        ),
        /* @__PURE__ */ jsx("div", { className: cn("flex flex-col gap-3 px-5 pt-0 pb-4", isDesktop && "px-6 pb-6"), children })
      ]
    }
  );
};
const CertificationCard = ({
  isLoading = false,
  variants = "certification",
  title,
  children,
  hasArrow = false,
  buttons,
  right,
  className,
  onClick,
  ubikey
}) => {
  const { isDesktop } = useDevice();
  console.log("right", right, title);
  return /* @__PURE__ */ jsx(CertificationCardContext.Provider, { value: { variants, isLoading }, children: isLoading ? /* @__PURE__ */ jsx(CertificationCardSkeleton, { title, className, children }) : /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "certification-card w-full flex flex-col rounded-[12px] border border-basic-04 bg-base-white",
        onClick && "hover:border-interactive-tertiary-hovered cursor-pointer",
        !title && "pt-5",
        ubikey && "min-h-[182px]",
        className
      ),
      role: onClick ? "button" : void 0,
      tabIndex: 0,
      onClick: () => onClick?.(),
      onKeyDown: onClick ? (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      } : void 0,
      "aria-label": "인증서 선택 내보내기",
      children: [
        title && /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn(
              "flex items-center justify-between gap-2 p-5 pb-5",
              isDesktop && "p-6 pb-5"
            ),
            children: [
              /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ jsx(
                  LineIcon,
                  {
                    icoColor: "bg-icon-basic-01",
                    icoName: variants === "certification" ? "ico-shield-check" : variants === "otp" ? "ico-lock-key" : variants === "transfer" ? "ico-transfer-limit" : ""
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "body-lg font-weight-medium text-basic-02", children: title })
              ] }),
              ubikey ? /* @__PURE__ */ jsx("img", { src: Images.Ubikey, alt: "ubikey", className: "h-5 w-auto" }) : right ? right : hasArrow && /* @__PURE__ */ jsx(
                LineIcon,
                {
                  icoColor: "bg-icon-basic-01",
                  icoName: "ico-caret-right"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "flex flex-col gap-3 px-5 pt-0 pb-5",
              isDesktop && "px-6 pb-6"
            ),
            children
          }
        ),
        buttons && /* @__PURE__ */ jsx("div", { className: cn("px-5", isDesktop && "px-5"), children: /* @__PURE__ */ jsx("div", { className: "flex border-t border-t-basic-05", children: buttons?.map((button, idx) => /* @__PURE__ */ jsx(
          "button",
          {
            className: "relative flex-1 pt-4 pb-5 inline-flex items-center justify-center body-md font-weight-medium text-primary-04 last:after:content-none after:contents-[''] after:absolute after:right-0 after:top-4 after:w-[1px] after:h-[16px] after:bg-basic-background-04",
            onClick: (e) => {
              e.stopPropagation();
              button?.onClick?.();
            },
            children: button.title
          },
          `btn-${idx}`
        )) }) })
      ]
    }
  ) });
};
const CertificationCardInfoSkeleton = () => {
  return /* @__PURE__ */ jsx(Skeleton, { className: "w-full h-6" });
};
const CertificationCardInfo = ({
  title,
  desc,
  onClick
}) => {
  const cardProps = useContext(CertificationCardContext);
  const btnLinkRef = useRef(null);
  return cardProps?.isLoading ? /* @__PURE__ */ jsx(CertificationCardInfoSkeleton, {}) : /* @__PURE__ */ jsxs("dl", { className: "flex items-center justify-between gap-5", children: [
    /* @__PURE__ */ jsx(
      "dt",
      {
        className: cn(
          "text-basic-04",
          cardProps?.variants === "fx" ? "eng-body-lg" : "body-lg"
        ),
        children: title
      }
    ),
    desc && /* @__PURE__ */ jsx("dd", { className: cn("font-weight-medium text-basic-02 body-lg min-w-fit"), children: onClick ? /* @__PURE__ */ jsx("button", { className: "link", onClick, ref: btnLinkRef, children: desc }) : desc })
  ] });
};
const CertificationCardWrap = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-3", children });
};

export { CertificationCard, CertificationCardInfo, CertificationCardWrap };
